<template>
  <div id="values">
    <div class="row">
      <div class="col-12 d-flex justify-content-between flex-wrap">
        <div style="flex:1;" class="d-flex align-items-center">
            <h2 class="view-title">Valores predeterminados</h2>
        </div>

        
        <div class="container-actions-dashboard d-flex justify-content-between mt-2 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
          <button class="btn btn-outlined mx-2 d-flex align-items-center" @click="redirectToconfigurations()">
            <img src="@/assets/icons/undo.svg" alt width="15px" class="mr-2" />
            Regresar a configuración
          </button>
          <button class="btn btn-save ml-2 d-flex align-items-center" @click="saveChanges()">
            <img src="@/assets/icons/guardar.svg" width="18" class="mr-2">
            Guardar cambios
          </button>
        </div>
      </div>
    </div>
    <div class="row">
        <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 mt-2">
            <p class="subtitle-info-section my-3">
                Esta información será precargada y utilizada como base para las nuevas cotizaciones. Realizar cambios en este menú no afectará las cotizaciones pasadas.
            </p>
        </div>
    </div>
    <div class="row pb-5">
        <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-8 mb-4">
            <div class="cotizarlo-general-wrapper wrapper-padding">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex align-items-center mb-3">
                            <h3 class="subtitle-section my-0">Valores definidos</h3>
                            <span class="ml-2 icon-cot-info" v-tooltip='"Estos serán los valores que cargarán todas las nuevas cotizaciones que envíes. Cambiar estos valores no afectará las cotizaciones ya enviadas."'></span>
                        </div>
                    </div>
                </div>
                
                <div class="form-row mt-3">
                    <div class="col">
                        <div class="form-group">
                            <div class="input-group flex-nowrap d-flex">
                                <div class="input-group-prepend w-50 flex-fill">
                                    <div class="input-group-text w-100 d-none d-sm-none d-md-block d-lg-block d-xl-block">
                                        Validez de la cotización
                                    </div>
                                    <div class="input-group-text w-100 d-block d-sm-block d-md-none d-lg-none d-xl-none" style="border-radius: 0.85rem 0 0 0.85rem !important;">
                                        Validez 
                                    </div>
                                </div>
                                <div class="input-append-select flex-fill w-50">
                                    <button class="cotizarlo-select dropdown-toggle my-0 text-right" type="button" id="menuTax" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="border:none">
                                        <span>{{values.days_validity}}</span>
                                        <img class="dropdown-icon mx-2" src="@/assets/icons/abajo_blue.svg" width="15px"/>
                                        <span>días</span>
                                    </button>
                                    <div class="dropdown-menu dropdown-select-menu" aria-labelledby="menuTax" style="max-height:300px; overflow-y:scroll">                  
                                        <div class="dropdown-item d-flex py-1" @click="selectValidity(15)">
                                            <span>15 días</span>
                                        </div> 
                                        <div class="dropdown-item d-flex py-1" @click="selectValidity(30)">
                                            <span>30 días</span>
                                        </div> 
                                        <div class="dropdown-item d-flex py-1" @click="selectValidity(45)">
                                            <span>45 días</span>
                                        </div> 
                                        <div class="dropdown-item d-flex py-1" @click="selectValidity(60)">
                                            <span>60 días</span>
                                        </div> 
                                        <div class="dropdown-item d-flex py-1" @click="selectValidity(90)">
                                            <span>90 días</span>
                                        </div>
                                    </div>       
                                </div>
                            </div>
                        </div>
                    </div>  
                    <div class="col">
                        <div class="form-group">
                            <div class="input-group flex-nowrap d-flex">
                                <div class="input-group-prepend w-50 text-center">
                                    <div class="input-group-text w-100 d-flex justify-content-center">
                                        <span>Descuento</span>
                                    </div>
                                </div>
                                <div class="input-append" >
                                    <input
                                    type="number"
                                    min="0"
                                    class="form-control text-right"
                                    v-model="values.discount"
                                    style="border-radius:0;"
                                    /> 
                                </div>
                                <div class="input-group-append">
                                    <div class="input-group-text" style="border-radius: 0px 12px 12px 0px;"> % </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>   
                </div>
                <div class="form-row mt-2">
                     <div class="col">
                        <div class="form-group">
                            <div class="input-group flex-nowrap d-flex">
                                <div class="input-group-prepend w-50">
                                    <div class="input-group-text w-100 d-flex justify-content-center">
                                        Folio en curso
                                    </div>
                                </div>
                                <div class="input-append w-50">
                                    <input
                                    type="number"
                                    min="0"
                                    class="form-control text-right"
                                    v-model="values.folio"
                                    /> 
                                </div>
                            </div>
                            
                        </div>
                    </div>
                      <div class="col">
                        <div class="form-group">
                            <div class="input-group flex-nowrap d-flex">
                                <div class="input-group-prepend w-50 flex-fill">
                                    <div class="input-group-text w-100 d-flex justify-content-center">
                                        Moneda
                                    </div>
                                </div>
                                <div class="input-append-select flex-fill w-50">
                                    <button 
                                      class="cotizarlo-select dropdown-toggle my-0 text-right pr-0 disabled" 
                                      type="button" 
                                      id="menuTax" 
                                      data-toggle="dropdown" 
                                      aria-haspopup="true" 
                                      aria-expanded="false" 
                                      style="border: none; cursor: default;"
                                    >
                                      <span class="mr-3">{{values.currency}}</span>
                                      <!--img class="dropdown-icon mx-2" src="@/assets/icons/abajo_blue.svg" width="15px"/-->
                                    </button>
                                    <div class="dropdown-menu dropdown-select-menu" aria-labelledby="menuTax" style="max-height:300px; overflow-y:scroll">                  
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('MXN')">
                                            <span>MXN</span>
                                        </div> 
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('USD')">
                                            <span>USD</span>
                                        </div>
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('ARP')">
                                            <span>ARP</span>
                                        </div> 
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('BOB')">
                                            <span>BOB</span>
                                        </div>
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('BRL')">
                                            <span>BRL</span>
                                        </div>
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('CLP')">
                                            <span>CLP</span>
                                        </div>
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('COP')">
                                            <span>COP</span>
                                        </div>
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('CRC')">
                                            <span>CRC</span>
                                        </div>
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('CUP')">
                                            <span>CUP</span>
                                        </div>
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('DOP')">
                                            <span>DOP</span>
                                        </div>
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('GTQ')">
                                            <span>GTQ</span>
                                        </div>
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('HTG')">
                                            <span>HTG</span>
                                        </div>
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('HNL')">
                                            <span>HNL</span>
                                        </div>
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('NIO')">
                                            <span>NIO</span>
                                        </div>
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('PYG')">
                                            <span>PYG</span>
                                        </div>
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('PEN')">
                                            <span>PEN</span>
                                        </div>
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('UYU')">
                                            <span>UYU</span>
                                        </div>
                                        <div class="dropdown-item d-flex py-1" @click="selectCurrency('VES')">
                                            <span>VES</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
                <div class="form-row mt-2">    
                    <div class="col">
                       <div class="form-group">
                            <div class="input-group flex-nowrap d-flex">
                                <div class="input-group-prepend w-50">
                                    <div class="input-group-text w-100 d-none d-sm-none d-md-block d-lg-block d-xl-block">
                                        Incluir impuesto
                                    </div>
                                    <div class="input-group-text w-100 d-block d-sm-block d-md-none d-lg-none d-xl-none" style="border-radius: 0.85rem 0 0 0.85rem !important;">
                                        Impuesto 
                                    </div>
                                </div>
                                    <div class="input-append-select w-50">
                                        <button class="cotizarlo-select dropdown-toggle my-0 text-right" type="button" id="menuTax" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="border:none">
                                            <span v-if="values.iva == 1">Sí</span>
                                            <span v-else>No</span>
                                            <img class="dropdown-icon mx-2" src="@/assets/icons/abajo_blue.svg" width="15px"/>
                                           
                                        </button>
                                        <div class="dropdown-menu dropdown-select-menu" aria-labelledby="menuTax" style="max-height:300px; overflow-y:scroll">                  
                                            <div class="dropdown-item d-flex py-1" @click="selectIva(1)">
                                                <span>Incluir</span>
                                            </div> 
                                            <div class="dropdown-item d-flex py-1" @click="selectIva(0)">
                                                <span>No incluir</span>
                                            </div>
                                        </div>       
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col w-25">
                        <div class="form-group">
                            <div class="input-group flex-nowrap">
                                <div class="input-group-prepend w-50">
                                    <div class="input-group-text w-100 d-none d-sm-none d-md-block d-lg-block d-xl-block">
                                        Valor del impuesto
                                    </div>
                                    <div class="input-group-text w-100 d-block d-sm-block d-md-none d-lg-none d-xl-none" style="border-radius: 0.85rem 0 0 0.85rem !important;">
                                        Valor impuesto
                                    </div>
                                </div>
                                <div class="input-append w-50">
                                    <input
                                    type="number"
                                    min="0"
                                    class="form-control text-right"
                                    v-model="values.amount_iva"
                                    /> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>               
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-4">
            <div class="cotizarlo-general-wrapper wrapper-padding">
                <div class="row mb-3">
                    <div class="col-12">
                        <div class="d-flex align-items-center">
                            <h3 class="subtitle-section my-0">Categoría de ventas</h3>
                            <span class="ml-2 icon-cot-info" v-tooltip='"La categoría de ventas es únicamente para uso interno y funje como organizador de productos. Por ejemplo, si vendes pelotas de muchos colores, puedes crear la categoría de \"Pelotas|\" y asignarla a cada SKU para tenerlas agrupadas."'></span>
                        </div>
                    </div>
                </div>
                
                <p class="content-text">Crea categorías para organizar mejor tus productos o servicios dentro de la plataforma. La estrella selecciona la que utilizarás por defecto al crear uno nuevo. Recuerda que este es un dato completamente interno y no será visto por el cliente.</p>
                <div class="form-row">
                    <div class="col">
                        <div class="form-group">
                            <div class="input-field form-control">
                            <input type="text" class="main-input " id="category" v-model="category.name" placeholder="_" required>
                            <label for="category" class="main-label">Agregar categoría</label>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col">
                        <div class="form-group">
                            <div class="input-field form-control">
                            <input type="text" class="main-input " id="iva" v-model="category.iva" >
                            <label for="iva" class="main-label">IVA</label>
                            </div>
                        </div>

                    </div> -->
                    <img class="pointer-hover ml-3 mb-2" src="@/assets/icons/plus_navy.svg" width="20px" @click="addCategory()"/>   
                </div>


                <div class="form-row" v-if="showEditCategoryForm">
                    <div class="col">
                        <div class="form-group">
                            <div class="input-field form-control">
                            <input type="text" class="main-input " id="editName" v-model="editForm.name">
                            <label for="editName" class="main-label">Categoria</label>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col">
                        <div class="form-group">
                            <div class="input-field form-control">
                            <input type="text" class="main-input " id="editIva" v-model="editForm.iva" >
                            <label for="editIva" class="main-label">IVA</label>
                            </div>
                        </div>

                    </div> -->
                    <img src="@/assets/icons/cancelar.svg" width="18" class="mr-2 hover-pointer" @click="cancelEditCategory()">
                    <img src="@/assets/icons/guardar_navy.svg" width="15" class="hover-pointer" @click="confirmEditCategory()">
                </div>

                <div 
                class="d-flex align-items-start justify-content-between my-2" 
                v-for="(category) in categories"
                :key="category.id"
                >
                    <div class="w-50 pr-1">
                        <p class="content-text my-0">{{category.name}}</p>
                        <!-- <p class="text-inactive small my-0">{{category.iva}}% de IVA</p> -->
                    </div>
                    <div class="w-50 pl-2">
                        <img v-if="category.default == 1" src="@/assets/icons/full_star.svg" alt="" class="mr-3 pointer-hover" width="20px">
                        <img class="pointer-hover mr-3 pointer-hover" src="@/assets/icons/estrella.svg" width="20px" v-else @click="selectDefaultCategory(category)"/>
                        <img class="pointer-hover mr-3 pointer-hover" src="@/assets/icons/edit.svg" width="20px" @click="editCategory(category)"/>
                        <img class="pointer-hover mr-3 pointer-hover" src="@/assets/icons/delete.svg" width="20px" @click="deleteCategory(category.id)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import data from '@/mixins/data'
import methods from '@/mixins/methods'
import { validationMixin } from 'vuelidate'


//IMPORT DE SERVICIOS
import profileConfiguration from '@/api/profile_configuration.js'

export default {
  mixins: [data, methods, validationMixin],
  components: { },

  beforeMount() {
    this.getValuesData()
    this.getCategoriesData()
  },
  data() {
    return {
      values : {
        days_validity : null,
        folio : null,
        currency : null,
        iva : null,
        amount_iva : null,
        discount: null
      },
      categories : [],
      category :{
          name : null,
          iva : null,
          default : 0
      },
      editForm :{
          name : null,
          iva : null,
          id : null,
      },
      showEditCategoryForm : false
    }
  },
  methods: {
    getValuesData(){
        this.values.days_validity = this.configuration.days_validity
        this.values.folio = this.configuration.folio
        this.values.currency  = this.configuration.currency
        this.values.iva = this.configuration.iva
        this.values.amount_iva = this.configuration.amount_iva
        this.values.discount = this.configuration.discount

    },

    getCategoriesData(){
        profileConfiguration
        .getCategories()
        .then((response) => {
            this.categories = response.data.data
        })
        .catch(() => {
            this.$store.dispatch('showLoader',{show:false});
        });
    },

    selectValidity(days){
      this.values.days_validity = days
    },

    selectCurrency(currency){
      this.values.currency = currency
    },
    selectIva(iva){
      this.values.iva = iva
    },
    addCategory(){
        if(this.category.name != null && this.category.name != ""){
            let data = new FormData()
            data.append("name", this.category.name)
            // data.append("iva", this.category.iva)
            data.append("default", this.category.default)

            profileConfiguration
            .createCategory(data)
            .then(() => {
                this.$store.dispatch('updateUser').then(
                    () => {
                        this.getCategoriesData()
                        this.category.name = null
                    }
                )
            })
            .catch(() => {
                this.$store.dispatch('showLoader',{show:false});
            });
        }else{
            this.$store.dispatch('showMessage',{
                action:'error',
                message:'El nombre de la categoría es requerido para poder agregar una nueva categoría.'
            });
        }

    },
    deleteCategory(id){
        profileConfiguration
        .deleteCategory(id)
        .then(() => {
            this.$store.dispatch('updateUser').then(
                () => {
                    this.getCategoriesData()
                }
            )
        })
        .catch(() => {
            this.$store.dispatch('showLoader',{show:false});
        });

    },
    selectDefaultCategory(categoryData){

        let data = new FormData()

        data.append("name", categoryData.name)
        // data.append("iva", categoryData.iva)
        data.append("default", 1)

        profileConfiguration
        .updateCategory(data, categoryData.id)
        .then(() => {
            this.$store.dispatch('updateUser').then(
                () => {
                    this.getCategoriesData()
                }
            )
        })
        .catch(() => {
            this.$store.dispatch('showLoader',{show:false});
        });
   
    },
    editCategory(categoryData){
        this.editForm.name = categoryData.name
        // this.editForm.iva = categoryData.iva
        this.editForm.id = categoryData.id
        this.showEditCategoryForm = true
    },
    cancelEditCategory(){
        this.showEditCategoryForm = false
    },
    confirmEditCategory(){
        let data = new FormData()

        data.append("name", this.editForm.name)
        // data.append("iva", this.editForm.iva)
        profileConfiguration
        .updateCategory(data, this.editForm.id)
        .then(() => {
            this.showEditCategoryForm = false;
            this.$store.dispatch('updateUser').then(
                () => {
                    this.getCategoriesData()
                }
            )
        })
        .catch(() => {
            this.$store.dispatch('showLoader',{show:false});
        });
    },
    saveChanges(){
        this.$store.dispatch('showLoader',{show:true});

        let data = new FormData()
        data.append("days_validity",this.values.days_validity)
        data.append("folio",this.values.folio)
        data.append("currency",this.values.currency)
        data.append("iva",this.values.iva)
        data.append("amount_iva",this.values.amount_iva)
        data.append("discount",this.values.discount)

        profileConfiguration
        .updateDefaultValues(data)
        .then(() => {
            this.$store.dispatch('client/updateConfiguration').then(
            () => {
                this.$store.dispatch('showLoader',{show:false});
                this.$store.dispatch('showMessage',{
                action:'success',
                message:"Los valores predeterminados han sido actualizados con éxito"
                });  
            }
            );
        })
        .catch(() => {
            this.$store.dispatch('showLoader',{show:false});            
        });
    },
    redirectToconfigurations(){
        if (confirm('¿Estás seguro?')) this.$router.push('/configuracion');
    }
  },
  validations: {
   
  }
}
</script>